import { captureError } from '@/config/sentry';
import { chunkPreloadErrors, handleChunkLoadError } from '@/utils/pwa/preloadErrorHandler';
import { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router';
import { ErrorScreen } from '../ErrorScreen/ErrorScreen';

const reloadAtPath = (pathname: string, search: string, hash: string) => {
  const targetPath = pathname + search + hash;
  const currentPath = globalThis.location.pathname + globalThis.location.search + globalThis.location.hash;

  if (currentPath === targetPath) {
    console.log('[ErrorBoundary] Paths match, calling handleChunkLoadError');
    handleChunkLoadError('preload');
  } else {
    console.log(`[ErrorBoundary] Paths differ, navigating to: "${targetPath}"`);
    globalThis.location.href = targetPath;
  }
};

export const ErrorBoundary = () => {
  const error = useRouteError();
  const location = useLocation();

  useEffect(() => {
    if (!error) return;

    const isPreloadError = error instanceof Error && chunkPreloadErrors.has(error);

    if (isPreloadError) {
      console.log('Chunk preload error detected, reloading to get fresh assets');
      chunkPreloadErrors.delete(error);
      reloadAtPath(location.pathname, location.search, location.hash);
      return;
    }

    captureError(error);
  }, [error, location]);

  return <ErrorScreen withSeoTitle />;
};
